import React, { useState, useContext, useEffect,useRef } from 'react';
import { UserContext } from '../../context/provider/UserProvider';
import Logobeex from '../../assets/images/Logobeex.fw.png'


export const Principal = () => {
    const { stateUser, signOut } = useContext(UserContext)

    useEffect(()=>{
        console.log("ENTRO A LA PAGINA PRINCIPAL")
    },[])

    console.log("ENTRO A LA PAGINA PRINCIPAL")

    // const loadURL = () => {
    //   const url = 'https://www.bbva.pe/'; // Reemplaza con la URL que desees cargar
    //   iframeRef.current.src = url;
    // };
  

    return (
        <>
            {/* <div>Bienvenido</div> */}
            <div className=' center flex mt-20 justify h-auto '>
                {/* <img className='w-full opacity-10 ' src={Logobeex}/> */}
            </div>
        </>
    )
}

